var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45975 4.70117L9.28812 36.4265L21.9807 39.9507L34.7077 36.4224L37.5389 4.70255H6.45837L6.45975 4.70117ZM18.1857 12.9168L17.6234 19.0232L30.921 19.0245L30.8261 20.0695L29.9117 30.3133L29.854 30.9705L21.8735 33.1829L13.904 30.9705L13.3595 24.8614H17.2645L17.5422 27.9648L21.879 29.1335L26.2185 27.962L26.6695 22.9158L13.3719 22.9144L13.4667 21.8694L14.3811 11.6257L14.6685 8.75742H30.1881L30.3682 10.9547L30.9224 17.0775H27.016L26.6557 13.0598L22.6834 12.8205H21.9752V12.815L18.1871 12.9168H18.1857Z",
    fill: "#CACFE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.02c7dc091b2420de60d005f88ffe3a63.svg";
export { ForwardRef as ReactComponent };